export const DEFAULT_QUANTITY_PACK = 'default-quantity-pack';
export const ADDITIONAL_MARKETING_CONTACTS = 'additional-marketing-contacts';
export const ADDITIONAL_LEGACY_CONTACTS = 'additional-legacy-contacts';
export const ADDITIONAL_SALES_SEATS = 'additional-sales-seats';
export const ADDITIONAL_SERVICE_SEATS = 'additional-service-seats';